<template>
    <div id="career-apply" class="page career-apply">
        <div class="career-apply__head">
             <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb breadcrumb--desctop">
                            <router-link :to="{ name:'Home'}">
                                {{ lang('breadcrumb_kezdooldal') }}
                            </router-link>
                            <span class="separate">></span>
                            <router-link :to="{ name:'Career_' + currentLangName()}">
                                {{ lang('breadcrumb_allasajanlatok') }}
                            </router-link>
                            <span class="separate">></span>
                            <span class="current-news">{{selectedPos}}</span>
                        </div>
                        <div class="breadcrumb--mobile breadcrumb">
                            <router-link :to="{ name:'Career_' + currentLangName()}">
                                 {{ lang('vissza_az_allasajanlatokhoz') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1>{{ lang('career_jelentkezesi_lap') }}</h1>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="career-apply__content">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-md-10 col-xl-8 offset-md-1 offset-xl-2">
                        <div v-if="formSuccess===false" class="form-wrap">
                            <validation-observer  v-slot="{ handleSubmit }" tag="div">
                                <form @submit.prevent="handleSubmit(formSubmit)"  class="career-apply-form" enctype="multipart/form-data" @click="tryFill()">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group last_name-row">
                                                <ValidationProvider rules="required" v-slot="{ errors }"> 
                                                    <label for="career_last_name">{{lang('careerForm_vezeteknev')}}</label>
                                                    <input v-model="careerPositionsForm.last_name" type="text" class="form-control" id="career_last_name" :name="lang('careerForm_vezeteknev')" :placeholder="lang('career_vezeteknev_placeholder')" />
                                                    <span class="form__error">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="form-group first_name-row">
                                                <ValidationProvider rules="required" v-slot="{ errors }"> 
                                                    <label for="career_first_name">{{lang('careerForm_keresztnev')}}</label>
                                                    <input v-model="careerPositionsForm.first_name" type="text" class="form-control" id="career_first_name" :name="lang('careerForm_keresztnev')" :placeholder="lang('career_kersztnev_placeholder')" />
                                                    <span class="form__error">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>                                                                
                                    <div class="form-group email-row">
                                        <ValidationProvider rules="email|required" v-slot="{ errors }"> 
                                            <label for="career_email">{{lang('careerForm_email')}}</label>
                                            <input v-model="careerPositionsForm.email" type="text" class="form-control" id="career_email" :name="lang('careerForm_email')" :placeholder="lang('careerForm_email_placeholder')" />
                                            <span class="form__error">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group phone-row">
                                        <ValidationProvider rules="required" v-slot="{ errors }"> 
                                            <label for="career_phone">{{lang('careerForm_telefon')}}</label>
                                            <input v-model="careerPositionsForm.phone" type="text" class="form-control" id="career_phone" :name="lang('careerForm_telefon')" placeholder="+36 1 1234 567" />
                                            <span class="form__error">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group position-row">
                                        <ValidationProvider rules="required" v-slot="{ errors }"> 
                                            <label for="career_position">{{lang('careerForm_pozicio')}}</label>
                                            <v-select :name="lang('careerForm_pozicio')" v-model="careerPositionsForm.position" id="career_position" :options="currentPositions" :reduce="option => option.name" label="name" :placeholder="lang('careerForm_pozicio_placeholder')">                                        
                                            </v-select>
                                            <span class="form__error">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group file-row">
                                        <div id="file-upload">
                                            <label for="file">
                                                {{lang('careerForm_file_csatolas')}}
                                            </label>
                                            <div class="file-upload-inner">
                                                <ValidationProvider ref="provider" rules="required|fileFormat|fileSize" v-slot="{validate, errors }"> 
                                                    <span class="file-name">{{file.name}}</span>
                                                    <div class="file-search-btn"> {{lang('careerForm_file_csatolas_kereses_gomb')}}</div>
                                                    <input :name="lang('careerForm_file')"  type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                                                    <span class="form__error">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group msg-row">
                                        <label for="career_msg">{{lang('careerForm_uzenet')}}</label>
                                        <textarea v-model="careerPositionsForm.message" type="text" class="form-control" id="career_msg" name="career_msg"/>
                                    </div>
                                    <div class="custom-control custom-checkbox condition-row">
                                        <ValidationProvider rules="required|acceptConditions" v-slot="{ errors }"> 
                                            <input :name="lang('careerForm_aszf')" true-value="accepted" false-value="no" v-model="careerPositionsForm.condition" type="checkbox" class="custom-control-input" id="career_condition">
                                            <label v-if="privacyPolicyData.download.length > 0" class="custom-control-label" for="career_condition">
                                                {{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa1')}}
                                                 <a :href="privacyPolicyData.download[0].document_id ? doc_url + '/' + privacyPolicyData.download[0].document_id.path + privacyPolicyData.download[0].document_id.file_name + '?' + aszfTimeStamp : ''" target="_blank">{{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa2')}}</a>                                                
                                                {{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa3')}}
                                            </label>
                                            <label v-else class="custom-control-label" for="career_condition">
                                                {{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa1')}}
                                                {{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa2')}}
                                                {{lang('careerForm_adatkezelesi_tajekoztato_elfogadasa3')}}
                                            </label>
                                            <span class="form__error">{{ errors[0] }}</span>
                                        </ValidationProvider>        
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input true-value="1" false-value="0"  v-model="careerPositionsForm.newsletter" type="checkbox" class="custom-control-input" id="career_newsletter">
                                        <label class="custom-control-label" for="career_newsletter">
                                            {{lang('careerForm_hirlevel_feliratkozas')}}
                                        </label>
                                    </div>
                                    <div class="btn-wrap">
                                        <button type="submit" class="btn btn--primary"><span> {{lang('careerForm_jelentkezes_gomb')}}</span></button>
                                    </div>
                                </form>
                            </validation-observer>
                        </div>
                        <div v-else-if="formSuccess===true" class="career-apply--success-wrap">
                            <div class="title">{{lang('careerForm_sikeres_jelentkezes')}}</div>
                            <div class="newsletter-error" v-if="newsletterAlready">
                                {{lang('career_emai_cim_mar_feliratkozott')}}
                            </div>
                            <button class="btn btn--primary" @click="setFormStatusDefault()">
                                <span>{{lang('careerForm_uj_jelentkezes_gomb')}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import $ from "jquery"
import { ValidationProvider, ValidationObserver, extend  } from 'vee-validate';
import { required, email  } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

//localize messages was setting in the app.vue

setInteractionMode('eager');
extend('email', {
  ...email    
});
extend('required', {
  ...required   
});
extend('acceptConditions', {
    validate(value) {
        return value == "accepted" ? true : false
    }    
})
extend('fileFormat', {
    validate(value) {                
                
        let fileName = value.name
        let fileExtension = fileName.substring( fileName.lastIndexOf('.') + 1, )                

        if (fileExtension == 'doc' || fileExtension == 'docx' || fileExtension=='pdf') {
            return true
        } else {
            return false
        }                
    }    
})
extend('fileSize', {
    validate(value) {      
                        
        let maxFileSize = 1024 * 1024 * 2
        let fileSize = value.size        

        if ( fileSize > maxFileSize ) {
            return false
        } else {
            return true
        }                
    }    
})


export default {
    data(){
        return{
            currentPositions:[],
            careerPositionsForm: {
                last_name: '',
                first_name: '',
                email: '',
                phone: '',
                position: '',                
                message: '',
                condition: '', 
                newsletter: ''
            },            
            file: '',
            formSuccess: false,
            selectedPos: '',
            newsletterAlready: false,
            privacyPolicyData: {
                download: []
            },
            doc_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            triedFillForm : false            
        }
    }, 
    computed:{
        aszfTimeStamp(){
            return  Math.floor( Date.now() /1000)
        }
    },      
    components:{
        ValidationProvider,
        ValidationObserver        
    },
    methods:{
        getCurrentPositions(){
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?select[1]=name&where[0][0]=where&where[0][1]=type&where[0][2]=career&where[1][0]=where&where[1][1]=status&where[1][2]=1&order_by[0][0]=sort_order&order_by[0][1]=asc&order_by[1][0]=name&order_by[1][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                
                if (response.data.status == true ){
                    this.currentPositions = response.data.information
                } else {
                    this.currentPositions = [ {
                        name: 'Nincs aktuális állásajánlat',
                        id: -1
                    }]                    
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
            //validate the uploaded file
            this.$refs.provider.validate(this.file);
                      
        },
        formSubmit(){
            let _this = this            

            //if the newsletter was selected sign up to newsletter
            if ( parseInt(this.careerPositionsForm.newsletter) === 1){
                this.formSubmitNewsletter()
            }

            let formData = new FormData();            

            formData.append('last_name', this.careerPositionsForm.last_name)
            formData.append('first_name', this.careerPositionsForm.first_name)
            formData.append('email', this.careerPositionsForm.email )
            formData.append('phone', this.careerPositionsForm.phone )
            formData.append('position', this.careerPositionsForm.position )
            formData.append('message', this.careerPositionsForm.message )
            formData.append('condition', this.careerPositionsForm.condition )
            formData.append('file', this.file);            

            axios.post( process.env.VUE_APP_BIFROST_API_URL + '/candidate' ,  
                    formData,                
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    params:{
                        "language_id": this.$store.getters.getSelectedLang.id                         
                    }
                }
            ).then(response =>{
                
                if (response.data.status == true) { 
                    _this.setDataLayer('job_apply_form', 'submit', _this.careerPositionsForm.position)   
                    _this.sendSuccessEmail(_this.careerPositionsForm.email, this.careerPositionsForm.first_name, this.careerPositionsForm.last_name, '2')
                    var admin_data = JSON.parse(JSON.stringify(_this.careerPositionsForm));
                 
                    admin_data.file_link = '<a href="https://univer.hu/api/'+ response.data.result.candidate.file.path +  response.data.result.candidate.file.file_name +'">Feltöltött dokumentum</a>';
                    _this.sendAdminEmail(admin_data);
                    //set the default state
                    _this.formSuccess = true
                    _this.setDefaultState()
                }                                

            })
            .catch(function(error){
                if (error.response) {
                    // console.log('career error:', error.response.data.error);

                    let errorsArray = Object.entries(error.response.data.error);                    
                    
                    //remove the error-2 divs if there are
                    if ($('.career-apply-form .form__error-2').length > 0){
                        $('.career-apply-form .form__error-2').each(function(){
                            $(this).remove();                            
                        })
                    }
                    //write the errors
                    for (const [errorName, errorValue] of errorsArray) {                         
                        $('.career-apply-form .'+ errorName + '-row').append('<div class="form__error-2">'+ errorValue +'</div>')                    
                    }
                }
            });

            
        },
        setDefaultState(){    
            this.careerPositionsForm.last_name = '',
            this.careerPositionsForm.first_name = '',
            this.careerPositionsForm.email = ''
            this.careerPositionsForm.phone = ''
            this.careerPositionsForm.position = ''
            this.careerPositionsForm.message = ''
            this.careerPositionsForm.condition = ''
            this.careerPositionsForm.newsletter = ''
            this.file = '',
            this.newsletterAlready = false            
        },
        setFormStatusDefault(){
            this.formSuccess = false
        },
        formSubmitNewsletter(){
            var _this = this;
            /*let userEmailAddress = _this.careerPositionsForm.email
            let userNameFirstName = _this.careerPositionsForm.first_name
            let userNameLastName = _this.careerPositionsForm.last_name*/

            axios.get('/nwl/nwlSubscribe.php'+ '?first_name=' +this.careerPositionsForm.first_name +"&last_name=" + this.careerPositionsForm.last_name + "&email="+ this.careerPositionsForm.email+"&condition="+this.careerPositionsForm.condition)
            .then(response => {    
                    console.log(response)   
                        
            })
            .catch(function (error) {
                // console.log('newletter error', error)                       
                
                //write the errors from the server to the user
                if (error.response) {                    

                    let errorsArray = Object.entries(error.response.data.error);
                    let newsletterAlready = false                    
                    
                    for (const [errorName, errorValue] of errorsArray) {     
                        if ( errorName == 'email' && errorValue == 'A(z) Email -nek egyedinek kell lennie!') {
                            newsletterAlready = true                
                        }                                            
                    }  
                    
                    _this.newsletterAlready = newsletterAlready
                }
            });
        },
        sendSuccessEmail(userEmail, userNameFirstName, userNameLastName, templateId){
            let langId = this.$store.getters.getSelectedLang.id

            axios.post(process.env.VUE_APP_BIFROST_API_URL + '/emailsender/'+ templateId + '/' + langId, {
                to: userEmail,
                data_replace: {
                    first_name: userNameFirstName,
                    last_name: userNameLastName
                }   
            })            
            .catch(function (error) {
                console.log(error)
            });
        },  
        sendAdminEmail(formdata){
            console.log(formdata);
             axios.post(process.env.VUE_APP_BIFROST_API_URL + '/emailsender/'+ 3 + '/' + 1, {
                to: 'karrier@univer.hu',
                data_replace:formdata,
                
            })            
            .catch(function (error) {
                console.log(error)
            });
        } ,  
        getPrivacyPolicyData(){
            let _this = this                

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/318?relations=1&where[0][0]=where&where[0][1]=status&where[0][2]=1&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=language_status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc',{            
                params:{
                    "language_id": _this.$store.getters.getSelectedLang.id
                }
            }).then(response => { 
                             
                if (response.data.status == true ){                    
                    _this.privacyPolicyData.download = response.data.information[0].download
                } else {
                    _this.privacyPolicyData.download = []              
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },
         tryFill(){
            var _this = this;            
                                       
            $('form.career-apply-form').find('input[type=text], input[type=checkbox], input[type=file]').each(function(){
                $(this).change(function(){                        
                    if ( _this.triedFillForm != true) {                                                 
                        _this.setDataLayer('job_apply_form', 'start', _this.careerPositionsForm.position)
                        _this.triedFillForm = true;
                    }                                                                                             
                })
            })                        
        },
    },
    created(){
        this.getCurrentPositions()   
        this.getPrivacyPolicyData()  
        
        // localize(this.currentLangName())    
    },
    mounted(){
        let _this = this;

        setTimeout(()=>{
            let cPos = sessionStorage.getItem('_cPos')   
            _this.selectedPos = cPos
            _this.careerPositionsForm.position = cPos     
        }, 100)
        
    },
    destroyed(){
        sessionStorage.removeItem('_cPos');
    }
}
</script>